export default  {
    SERVER_BASE_URL: 'https://api.nearshop.in/igw/api',
    BK_OFFICE_SERVER_URL:'https://backoffice.nearshop.in'
}

// export default  {
//     SERVER_BASE_URL: 'https://api.nearshop.in/igw/api',
//     BK_OFFICE_SERVER_URL:'https://backoffice.nearshop.in/app'
// }
